import script from "./OLLSection.vue?vue&type=script&setup=true&lang=js"
export * from "./OLLSection.vue?vue&type=script&setup=true&lang=js"

import "./OLLSection.vue?vue&type=style&index=0&id=f6b8473e&scoped=true&lang=css"

import exportComponent from "C:\\JRIBIC\\Projects\\_myProjects\\_GIT\\general\\Vue.js\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f6b8473e"]])

export default __exports__